<template>
  <gl-table-two-columns title="Hashes" :rows="prepareData()" min-column-title />
</template>

<script>
import GlTableTwoColumns from '@gl/GlTableTwoColumns/GlTableTwoColumns'

export default {
  name: 'BlockHashes',
  components: { GlTableTwoColumns },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  methods: {
    prepareData() {
      return [
        {
          title: 'Hash',
          value: this.block?.hash || '',
          to: { name: 'Block', params: { id: this.block?.hash } },
        },
        {
          title: 'Previous Block',
          value: this.block?.previousblockhash || '',
          to: { name: 'Block', params: { id: this.block?.previousblockhash } },
        },
        {
          title: 'Next Block',
          value: this.block?.nextblockhash || '',
          to: { name: 'Block', params: { id: this.block?.nextblockhash } },
        },
        {
          title: 'Merkle Root',
          value: this.block?.merkleroot || '',
        },
      ]
    },
  },
}
</script>
